import { render, staticRenderFns } from "./SkillModal.vue?vue&type=template&id=51f3197e&scoped=true&"
import script from "./SkillModal.vue?vue&type=script&lang=js&"
export * from "./SkillModal.vue?vue&type=script&lang=js&"
import style0 from "./SkillModal.vue?vue&type=style&index=0&id=51f3197e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f3197e",
  null
  
)

export default component.exports